import React from 'react'

const Loader = () => {
    return (
        <div role="status">
            <div className='spinner'>
                <div></div>
            </div>
        </div>
    )
}

export default Loader;